import endpoint from "@/api/endpoint";

export default {

    get(){
        return window.axios.get(endpoint+'/api/vacancies');
    }

}
